/** import external dependencies */
// import 'jquery';
//import 'bootstrap-sass';

import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'bootstrap-sass/assets/javascripts/bootstrap/alert';


import 'lazysizes/plugins/bgset/ls.bgset.min.js';
import 'lazysizes';
import '../../node_modules/store/dist/store.modern.min';

/** import local dependencies */
import Router from './util/Router';

//import home from './routes/home';
//import aboutUs from './routes/about';
//import validate from 'jquery-validation';

/** Load Events */
//jQuery(document).ready(() => routes.loadEvents());

function addResponsiveVideoWrapper() {
    // Find all YouTube videos
        var $allVideos = $("iframe[src^='//www.youtube.com']"),

        // The element that is fluid width
        $fluidEl = $("body");

        // Figure out and save aspect ratio for each video
        $allVideos.each(function() {

        $(this)
        .data('aspectRatio', this.height / this.width)

        // and remove the hard coded width/height
        .removeAttr('height')
        .removeAttr('width');

        });

        // When the window is resized
        $(window).resize(function() {

        var newWidth = $fluidEl.width();

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function() {

        var $el = $(this);
        $el
        .width(newWidth)
        .height(newWidth * $el.data('aspectRatio'));

        });

        // Kick off one resize to fix all videos on page load
        }).resize();
}

function setActiveWorkshop() {

    let currentWorkshop = localStorage.getItem('workshop');
    let currentWorkshopObj = JSON.parse(currentWorkshop);
    
    if (currentWorkshopObj !== undefined && currentWorkshopObj !== null) {
        $('.js-selected-workshop').text(currentWorkshopObj.name);
    }

  }



function showSiteMsg() {
    
    let siteMsg = $('.site-msg');
    let siteMsgKey = $(siteMsg).data('key');
    let hasKeyTrue = localStorage.getItem('sitemsg-' + siteMsgKey);
    if (hasKeyTrue !== null) { hasKeyTrue = true; } else { hasKeyTrue = false; }
    
    if (siteMsg.length && !hasKeyTrue) {
        $('body').addClass('site-msg-visible');
        siteMsg.addClass('is-visible');
    }
}

function addSiteMsg(key) {
    localStorage.setItem('sitemsg-' + key, true);
    $('body').removeClass('site-msg-visible');
}

$(document).ready(function() {

    showSiteMsg();

    
    // orderpage: page-template-template-order-blade
    const body = $('body');
     if (body.hasClass('page-template-templatestemplate-workshop-find-blade-php')) {
        mapGeoLocation();
    }

    setActiveWorkshop();

    addResponsiveVideoWrapper();
   
    $('.js-close-site-msg').on('click', function(e) {
        $('.site-msg').removeClass('is-visible');
        let siteMsgDate = $('.site-msg').data('key');
        addSiteMsg(siteMsgDate);
    });

  $('input').on('focusin', function() {
      let container = $(this).parent();

      if( container.hasClass('btn') ) {
          container.addClass('active-border');
      }
  });

  $('input').on('focusout', function() {
      let container = $(this).parent();

      if( container.hasClass('btn') ) {
          container.removeClass('active-border');
      }
  });

  $('.dropdown-accordion').on('show.bs.dropdown', function (event) {
      var accordion = $(this).find($(this).data('accordion'));
      accordion.find('.panel-collapse.in').collapse('hide');
  });

  $('.faq-page .dropdown-menu li a').on('click', function(e){
      e.preventDefault();

      var target = $(this).attr('data-target');

      $('.dropdown__answer').hide();
      $("#"+target).show();
  });

  $('.bounce').on('click', function(){
      $('html, body').animate({
          scrollTop: $("#campaign").offset().top
      }, 600);
  });


  // hamburger click
  $('.js-hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('burger-is-active');
  });

  // on load, check localstorage for selected workshop.
  
  // save workshop in localstorage
  $('.js-choose-workshop').on('click', function(e) {
      //e.preventDefault();
      const workshopId = $(this).data('workshop-id');
      const workshopTitle = $(this).data('workshop-title')
      const workshopSlug = $(this).data('workshop-slug');
        
    
    const workshopObj = { id: workshopId, name: workshopTitle, slug: workshopSlug };
    localStorage.setItem('workshop', JSON.stringify(workshopObj));
      setActiveWorkshop();
  });
});

$(document).ready(function() {

    // workshop dropdown
    $('.workshop-dropdown').on('click', function() {
        // hide menu if open
        if ($('body').hasClass('burger-is-active')) {
            $('.js-hamburger').trigger('click');
        }
    });

    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

// Just show the first map
$('.workshop-item:first-child').removeClass('hidden');


// Select a workshop based on location
$('.js-geolocation-workshop').on('click', function() {
    // Make an array of all locations
    mapGeoLocation();
})

// Select a workshop when clicking
$('.map__select').on('change', function(e) {
    e.preventDefault();

    
    let src = $(`.workshop-item[data-id="${this.value}"]`).data('iframe-src');
    src = `<iframe frameborder="0" class="map__frame" allowfullscreen lazyload="on" src="${src}"></iframe>`;
    $(`.workshop-item[data-id="${this.value}"]`).find('.js-iframe').html(src);
    
    $('.workshop-item').addClass('hidden');
    $(`.workshop-item[data-id="${this.value}"]`).removeClass('hidden');
    var workshop_slug = $(this).find(':selected').data('slug');

    // if (history.pushState) {
    //     history.pushState(null, null, '#' + workshop_slug)
    // };
    
});

});

$(window).bind('popstate',  
function() {
    const body = $('body');
    if (!body.hasClass('page-template-templatestemplate-order-blade-php')) {
       mapGeoLocation();
       console.log('popstate');
   }
    
});

function mapGeoLocation() {

    
    // Make an array of all locations
    let locations = [];

    $('.map__select option').each(function() {
        if( $(this)[0].hasAttribute('data-lng') ) {
            locations.push( [$(this).attr('data-lat'), $(this).attr('data-lng')] );
        }
    })

    let currentWorkshop = localStorage.getItem('workshop');
    let currentWorkshopObj = JSON.parse(currentWorkshop);

    //if (currentWorkshopObj !== undefined && currentWorkshopObj !== null) {
   
    let workshopHash = window.location.hash;
    
    if(window.location.hash.length) {
            workshopHash = window.location.hash;
            workshopHash = workshopHash.substring(1);
            $('*[data-slug="'+ workshopHash  +'"]').prop('selected', true);
            var mapID = $('*[data-slug="'+ workshopHash  +'"]').val();
            $('.workshop-item').addClass('hidden');
            $('.workshop-item[data-id="'+ mapID +'"]').removeClass('hidden');
            setTimeout( () => {
                $('.map__select').val(mapID).trigger('change');
            }, 200);

        } else if (currentWorkshop !== null) {

                workshopHash = `#${currentWorkshopObj.slug}`;
                workshopHash = workshopHash.substring(1);
                $('*[data-slug="'+ workshopHash  +'"]').prop('selected', true);
                var mapID = $('*[data-slug="'+ workshopHash  +'"]').val();
                $('.workshop-item').addClass('hidden');
                $('.workshop-item[data-id="'+ mapID +'"]').removeClass('hidden');
                setTimeout( () => {
                    $('.map__select').val(mapID).trigger('change');
                }, 200);    
            
    } else {
        // Get user coordinates
        // check for locationStorage
        let currentWorkshop = localStorage.getItem('workshop');
        let currentWorkshopObj = JSON.parse(currentWorkshop);
        if (navigator.geolocation) {
            $('.map__loading').removeClass('hidden');
            jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAHB1A_24V5dKSlHMGZfKx3fgPmXCfJzA0", function(success) {
                if ( $( '.map__select' ).length ) {
                    nearestCity(success.location.lat, success.location.lng);
                } else {
                   
                }
            })
                .fail(function(err) {
                    // force workshop
                    const workshopId = '108';
                    const workshopTitle = 'Oslo';
                    const workshopSlug = 'oslo';   
                    
                    const workshopObj = { id: workshopId, name: workshopTitle, slug: workshopSlug };
                    localStorage.setItem('workshop', JSON.stringify(workshopObj));
                    setActiveWorkshop();
                });
        } else {
            nearestCity(locations[0][0], locations[0][1]);
        }
    }

    // Just show error msg
    function error() {
        $('.map__loading').addClass('hidden');
        $('.map__error').removeClass('hidden');
    }

    // Convert Degress to Radians
    function deg2Rad(deg) {
        return deg * Math.PI / 180;
    }

    function pythagorasEquirectangular(lat1, lon1, lat2, lon2) {
        lat1 = deg2Rad(lat1);
        lat2 = deg2Rad(lat2);
        lon1 = deg2Rad(lon1);
        lon2 = deg2Rad(lon2);

        const R = 6371;
        let x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
        let y = (lat2 - lat1);
        let d = Math.sqrt(x * x + y * y) * R;

        return d;
    }

    function nearestCity(latitude, longitude) {
        let mindiff = 99999;
        let closest;

      
        for (let i = 0; i < locations.length; i++) {
            var diff = pythagorasEquirectangular(latitude, longitude, locations[i][0], locations[i][1]);

            if (diff < mindiff) {
                closest = i;
                mindiff = diff;
            } else {
                // User is too far away ?
            }
        }

        let currentWorkshop = localStorage.getItem('workshop');
        let currentWorkshopObj = JSON.parse(currentWorkshop);
        let id;
        
        if(window.location.hash) {
            const hash = window.location.hash;
            console.log('hash', hash);
            id = $(`.map__select option[data-slug=${hash}]`);
        } else if (currentWorkshopObj !== undefined && currentWorkshopObj !== null) {
            console.log('workshop in localstorage');
            const slug = currentWorkshopObj.slug;
            id = $(`.map__select option[data-slug=${slug}]`);
        } else {
            console.log('fallback');
            id = $(`.map__select option[data-lat="${locations[closest][0]}"][data-lng="${locations[closest][1]}"]`).val();
        }

        // Show the closest location
        $('.map__loading').addClass('hidden');

        // let id = $(`.map__select option[data-lat="${locations[closest][0]}"][data-lng="${locations[closest][1]}"]`).val();
        $('.workshop-item').addClass('hidden');

        $(`.workshop-item[data-id="${id}"]`).removeClass('hidden');
        $(`.map__select option[value="${id}"]`).prop('selected','selected');
        $('.map__select').val(id).trigger('change');
        
        // let workshop_slug = $('.map__select option:selected').data('slug');
        
        // if (history.pushState && $('body').hasClass('page-template-template-workshop-blade')) {
        //     history.pushState(null, null, '#' + workshop_slug);
        // };
    }
}



function gm_authFailure() { 
    console.log('auth failed');
};


// WEBPACK FOOTER //
// ./scripts/main.js